module.exports = __webpack_public_path__ + "img/1459817244.094de8bd.jpg";